import React from 'react';
import { color } from '../../../../resources';
import { Icon } from '../../../../resources/icon';

export const requestStatusObg = {
  [10]: {
    icon: <Icon.Hourglass />,
    color: color.blue_why,
    label: 'รอตรวจสอบ',
  },
  [20]: {
    icon: <Icon.Truck />,
    color: color.yellow,
    label: 'กำลังจัดส่ง',
  },
  [30]: {
    icon: <Icon.PaperPlane />,
    color: color.line,
    label: 'เรียบร้อยแล้ว',
  },
  [40]: {
    icon: <Icon.Times />,
    color: color.edit,
    label: 'ไม่อนุมัติ',
  },
  [50]: {
    icon: <Icon.Cancel />,
    color: 'gray',
    label: 'ยกเลิกรายการ',
  },
};
